export default function HowTrainingGoes() {
  const steps = [
    { step: '01', icon: 'ri-search-line', title: 'Диагностика', desc: 'Изучаем текущий уровень и проблемы отдела' },
    { step: '02', icon: 'ri-headphone-line', title: 'Прослушивание звонков', desc: 'Анализируем 20-30 реальных разговоров менеджеров' },
    { step: '03', icon: 'ri-chat-1-line', title: 'Интервью', desc: 'Беседуем с руководителем, РОПом и самими менеджерами' },
    { step: '04', icon: 'ri-file-list-3-line', title: 'Подготовка программы', desc: 'Адаптируем обучение под продукт, цикл сделки и уровень команды' },
    { step: '05', icon: 'ri-presentation-line', title: 'Тренинг', desc: '1-2 дня интенсивной практики с отработкой на кейсах компании' },
    { step: '06', icon: 'ri-voiceprint-line', title: 'Разбор реальных звонков', desc: 'Вместе разбираем записи: что работает и что теряет клиента' },
    { step: '07', icon: 'ri-book-open-line', title: 'Домашние задания', desc: 'Закрепляем навыки между модулями на реальной работе' },
    { step: '08', icon: 'ri-user-follow-line', title: 'Сопровождение', desc: 'Telegram-поддержка, разбор звонков, корректировка стратегии' },
    { step: '09', icon: 'ri-bar-chart-box-line', title: 'Контроль внедрения', desc: 'Проверяем, как новые навыки закрепились в работе' },
  ];

  return (
    <section className="py-20 md:py-28 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-5xl font-bold text-gray-900 mb-6">
            Как проходит обучение
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed">
            От диагностики до контроля внедрения — полный цикл, который обеспечивает реальные изменения.
          </p>
        </div>

        <div className="relative">
          <div className="hidden lg:block absolute left-1/2 top-8 bottom-8 w-px bg-teal-200 -translate-x-1/2"></div>

          <div className="space-y-6 relative">
            {steps.map((item, i) => (
              <div key={i} className={`flex flex-col lg:flex-row items-start gap-6 lg:gap-10 ${i % 2 === 0 ? 'lg:flex-row' : 'lg:flex-row-reverse'}`}>
                <div className={`flex-1 ${i % 2 === 0 ? 'lg:text-right lg:pr-20' : 'lg:text-left lg:pl-20'}`}>
                  <div className={`bg-white rounded-xl p-5 md:p-6 shadow-sm hover:shadow-md transition-shadow ${i % 2 === 0 ? 'lg:ml-auto' : 'lg:mr-auto'}`}>
                    <div className="flex items-center gap-3 mb-3 lg:justify-start">
                      <div className={`w-10 h-10 bg-teal-600 rounded-lg flex items-center justify-center flex-shrink-0 ${i % 2 !== 0 ? 'order-first' : ''}`}>
                        <i className={`${item.icon} text-white text-lg`}></i>
                      </div>
                      <div className={`flex flex-col ${i % 2 === 0 ? 'lg:items-end' : 'lg:items-start'}`}>
                        <span className="text-xs font-semibold text-teal-600 tracking-wider">ШАГ {item.step}</span>
                        <h3 className="text-lg font-bold text-gray-900">{item.title}</h3>
                      </div>
                    </div>
                    <p className="text-sm text-gray-600 leading-relaxed">{item.desc}</p>
                  </div>
                </div>
                <div className="hidden lg:flex w-10 h-10 bg-teal-600 rounded-full items-center justify-center flex-shrink-0 relative z-10">
                  <span className="text-white text-xs font-bold">{item.step}</span>
                </div>
                <div className="hidden lg:block flex-1"></div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}